import { Box } from '@chakra-ui/react'
import { colors } from 'constants/constants';
import { getDiscountPrice } from 'helpers/discounts';
import React from 'react'
import { Discount } from 'types/generic';

interface DiscountPriceProps {
    price: number;
    discount: Discount;
    showMonth?: boolean;
}

const monthString = ' /mån'

const DiscountPrice = ({ price, discount, showMonth = true }: DiscountPriceProps): JSX.Element => {
    const roundedPrice = (Math.round(price * 100) / 100)
    return (
        <Box mb={5}>
            <Box style={{ fontSize: 14, textDecoration: 'line-through', color: colors.secondary['mediumGrey'], }}>{price}:- {showMonth && monthString} ordinarie pris</Box>
            <Box style={{ fontSize: 28, color: colors.system.error[900], fontWeight: 600 }}>{getDiscountPrice(roundedPrice, discount)}:-{showMonth && monthString}</Box>
        </Box>
    )
}

export default DiscountPrice;